// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"v0-z","displaySixCardTiles":"w0-z"};